const Config = {
    applicationURL: process.env.REACT_APP_applicationURL,
    serverURL: process.env.REACT_APP_serverURL,
    version: process.env.REACT_APP_version,
    GRAPHQL_ENDPOINT: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    MAP_API_KEY: process.env.REACT_APP_MAP_API_KEY,
    GMAP_API_KEY: process.env.REACT_APP_GMAP_API_KEY,
    webPushKey: process.env.REACT_APP_WEB_PUSH_KEY,
    errorLoggerEndpoint: process.env.REACT_APP_ERROR_LOGGER_ENDPOINT,
    posthogApiKey: process.env.REACT_APP_POSTHOG_API_KEY,
    // Insight AI backend (zelp-ai-poc). Optional: Insight AI is hidden when it isn't set.
    aiApiURL: process.env.REACT_APP_AI_API_URL
}

export default Config;
